import { AnimalWithTags } from "./types";

export const animalsWithTags = (selectedAnimals: Array<AnimalWithTags>, id?: string) =>
  (selectedAnimals ?? []).filter((animal) => animal?.node?.tags?.some((tag) => tag.tagId === id));

export const animalsWithoutTags = (selectedAnimals: Array<AnimalWithTags>, tagIdToCheck?: string) =>
  (selectedAnimals ?? []).filter((animal) => {
    return !animal?.node?.tags?.some((tag) => tag.tagId === tagIdToCheck);
  });
